import React from "react";
import PropTypes from "prop-types";

function CollapsibleJSON({ title, data, expandedSections, toggleSection, sectionKey }) {
	const isOpen = expandedSections[sectionKey] || false;
	return (
		<div className="debug-collapsible">
			<button
				className="debug-collapsible-header"
				onClick={() => toggleSection(sectionKey)}
			>
				<span className={`chevron ${isOpen ? "open" : ""}`}>&#9654;</span>
				{title}
			</button>
			{isOpen && (
				<pre className="debug-json-block">{JSON.stringify(data, null, 2)}</pre>
			)}
		</div>
	);
}

CollapsibleJSON.propTypes = {
	title: PropTypes.string.isRequired,
	data: PropTypes.any,
	expandedSections: PropTypes.object.isRequired,
	toggleSection: PropTypes.func.isRequired,
	sectionKey: PropTypes.string.isRequired,
};

export default CollapsibleJSON;
